import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, ArrowRight, Shield, Flame, Star } from 'lucide-react';
export function ColectiePricing() {
  const standardInclusions = ['Acces pe viață la cele 6 cursuri online complete (valoare 3.000 lei)', '24 de întâlniri săptămânale de grup cu meditație și Q&A (valoare 1.200 lei)', 'Reducere 20% la toate cursurile și evenimentele viitoare', 'Reducere 20% pe luminaabundentei.ro'];
  const premiumExtras = ['6 sesiuni individuale 1:1 cu Adrian (valoare 1.200 lei)', '6 ședințe de terapie Theta Healing® și susținere energetică (valoare 1.200 lei)', '1 retreat de weekend cu învățături în valoare de 2.000 lei (se achită doar cazarea și masa)', 'Reducere 30% la cursurile și workshopurile de pe luminaabundentei.ro'];
  const premiumInclusions = [...standardInclusions, ...premiumExtras];
  return <section id="inscriere" className="py-24 lg:py-32 bg-[#4F2E7E] relative scroll-mt-24 overflow-hidden" data-id="element-464">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/10 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-465" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-gold/5 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3 pointer-events-none" data-id="element-466" />

      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-467">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-468">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 text-balance" data-id="element-469">
            Hai să vedem ce primești și care este investiția ta
          </h2>
          <div className="h-1 w-24 bg-brand-gold rounded-full mx-auto" data-id="element-470" />
        </motion.div>

        {/* Two pricing cards */}
        <div className="grid lg:grid-cols-2 gap-8 mb-8" data-id="element-471">
          {/* Standard */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="bg-white rounded-[2rem] p-8 md:p-10 shadow-2xl flex flex-col" data-id="element-472">
            <div className="mb-6" data-id="element-473">
              <span className="inline-block text-xs uppercase tracking-wider font-bold text-brand-purple bg-brand-purple/10 px-3 py-1 rounded-full mb-3" data-id="element-474">
                Programul Standard
              </span>
              <h3 className="font-heading font-bold text-2xl text-brand-text mb-2" data-id="element-475">
                Ideal pentru a începe călătoria
              </h3>
              <p className="text-brand-textSec text-sm" data-id="element-476">
                Toate cele 6 cursuri + comunitate săptămânală
              </p>
            </div>

            <ul className="space-y-3 mb-6 flex-grow" data-id="element-477">
              {standardInclusions.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-478">
                  <div className="mt-1 bg-brand-gold/20 rounded-full p-1 flex-shrink-0" data-id="element-479">
                    <Check className="w-4 h-4 text-brand-gold" data-id="element-480" />
                  </div>
                  <span className="text-brand-text/80 text-sm" data-id="element-481">{item}</span>
                </li>)}
            </ul>

            {/* What Standard does NOT include */}
            <div className="mb-6 p-4 bg-brand-text/5 border border-brand-text/10 rounded-2xl" data-id="element-482">
              <p className="text-[11px] uppercase tracking-wider font-bold text-brand-textSec mb-3" data-id="element-483">
                Nu include (disponibil în Premium)
              </p>
              <ul className="space-y-2" data-id="element-484">
                {premiumExtras.map((item, idx) => <li key={idx} className="flex gap-2.5 items-start" data-id="element-485">
                    <div className="mt-0.5 bg-brand-text/10 rounded-full p-1 flex-shrink-0" data-id="element-486">
                      <X className="w-3.5 h-3.5 text-brand-text/50" data-id="element-487" />
                    </div>
                    <span className="text-brand-text/50 text-xs line-through" data-id="element-488">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="p-4 bg-brand-cream rounded-2xl mb-4 text-center" data-id="element-489">
              <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-bold text-brand-purple bg-brand-purple/10 px-2.5 py-1 rounded-full mb-2" data-id="element-490">
                <Star className="w-3 h-3" data-id="element-491" />
                Preț Membru Fondator
              </span>
              <span className="block text-xs text-brand-textSec line-through mb-1" data-id="element-492">
                Valoare reală 4.200 lei
              </span>
              <div className="flex items-baseline gap-2 justify-center" data-id="element-493">
                <span className="text-4xl md:text-5xl font-heading font-bold text-brand-gold" data-id="element-494">
                  1.200
                </span>
                <span className="text-xl font-bold text-brand-gold" data-id="element-495">lei</span>
              </div>
              <span className="block text-xs text-brand-textSec mt-1" data-id="element-496">
                ofertă valabilă până la 31 iulie 2026
              </span>
            </div>

            <a href="https://link.apisystem.tech/widget/form/VgQoyhxrZCM7kBd8kkEa" target="_top" className="group flex items-center justify-center gap-3 w-full bg-brand-purple text-white font-heading font-bold text-lg py-4 rounded-2xl hover:bg-brand-gold transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1" data-id="element-497">
              Vreau Programul Standard
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-498" />
            </a>
          </motion.div>

          {/* Premium */}
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} className="bg-gradient-to-br from-brand-text to-brand-purple rounded-[2rem] p-8 md:p-10 shadow-2xl text-white flex flex-col relative overflow-hidden" data-id="element-499">
            <div className="absolute top-0 right-0 w-48 h-48 bg-brand-gold/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none" data-id="element-500" />
            <div className="relative flex-grow flex flex-col" data-id="element-501">
              <div className="mb-6" data-id="element-502">
                <span className="inline-flex items-center gap-1 text-xs uppercase tracking-wider font-bold text-brand-text bg-brand-gold px-3 py-1 rounded-full mb-3" data-id="element-503">
                  <Flame className="w-3 h-3" data-id="element-504" />
                  Programul Premium
                </span>
                <h3 className="font-heading font-bold text-2xl mb-2 text-white" data-id="element-505">
                  Pentru transformare profundă, personalizată
                </h3>
                <p className="text-white/80 text-sm" data-id="element-506">
                  Tot ce e în Standard + 1:1, Theta Healing® și retreat
                </p>
              </div>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-507">
                {premiumInclusions.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-508">
                    <div className="mt-1 bg-brand-gold/20 rounded-full p-1 flex-shrink-0" data-id="element-509">
                      <Check className="w-4 h-4 text-brand-gold" data-id="element-510" />
                    </div>
                    <span className="text-white/90 text-sm" data-id="element-511">{item}</span>
                  </li>)}
              </ul>

              <div className="p-4 bg-white/10 backdrop-blur-sm rounded-2xl mb-4 text-center border border-white/20" data-id="element-512">
                <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-wider font-bold text-brand-text bg-brand-gold px-2.5 py-1 rounded-full mb-2" data-id="element-513">
                  <Star className="w-3 h-3" data-id="element-514" />
                  Preț Membru Fondator
                </span>
                <span className="block text-xs text-white/70 line-through mb-1" data-id="element-515">
                  Valoare reală 8.600 lei
                </span>
                <div className="flex items-baseline gap-2 justify-center" data-id="element-516">
                  <span className="text-4xl md:text-5xl font-heading font-bold text-brand-gold" data-id="element-517">
                    2.400
                  </span>
                  <span className="text-xl font-bold text-brand-gold" data-id="element-518">lei</span>
                </div>
                <span className="block text-xs text-white/80 mt-1" data-id="element-519">
                  ofertă valabilă până la 31 iulie 2026
                </span>
              </div>

              <a href="https://link.apisystem.tech/widget/form/VgQoyhxrZCM7kBd8kkEa" target="_top" className="group flex items-center justify-center gap-3 w-full bg-brand-gold text-brand-text font-heading font-bold text-lg py-4 rounded-2xl hover:bg-white transition-all duration-300 shadow-warm hover:shadow-warm-hover hover:-translate-y-1" data-id="element-520">
                Vreau Programul Premium
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-521" />
              </a>
            </div>
          </motion.div>
        </div>

        {/* Founder member info note */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white/5 backdrop-blur-sm border border-brand-gold/30 rounded-2xl p-6 text-center text-white/90 mb-8" data-id="element-522">
          <p className="text-sm md:text-base leading-relaxed" data-id="element-523">
            <strong className="text-brand-gold" data-id="element-524">
              Locuri limitate la 100 de participanți.
            </strong>{' '}
            Primele 50 de persoane care se înscriu până la{' '}
            <strong className="text-white" data-id="element-525">31 iulie 2026</strong> beneficiază de
            statutul de Membru Fondator și de prețul special. Înscrierile sunt
            deschise până la 28 august 2026 · Start oficial: 1 septembrie 2026.
          </p>
        </motion.div>

        {/* Individual courses note */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 text-center text-white/90 mb-8" data-id="element-526">
          <p className="text-sm md:text-base leading-relaxed" data-id="element-527">
            <strong className="text-white" data-id="element-528">Cursuri individuale:</strong> Fiecare
            curs se poate cumpăra separat la 500 lei. Recomandat este pachetul
            complet — cele 6 cursuri sunt gândite ca un proces progresiv în care
            fiecare construiește pe fundamentul celui anterior.
          </p>
        </motion.div>

        {/* Guarantee */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex items-start gap-4 bg-white/10 backdrop-blur-sm border border-brand-gold/30 rounded-2xl p-6 text-white" data-id="element-529">
          <div className="w-12 h-12 bg-brand-gold/20 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-530">
            <Shield className="w-6 h-6 text-brand-gold" data-id="element-531" />
          </div>
          <div data-id="element-532">
            <h4 className="font-bold text-lg mb-2 text-white" data-id="element-533">
              Garanția mea pentru tine
            </h4>
            <p className="text-white/90 text-sm leading-relaxed" data-id="element-534">
              Dacă parcurgi programul complet și nu vezi rezultate, primești
              acces suplimentar gratuit în Academie pentru încă 6 luni, ca să ai
              timp să aprofundezi și să practici mai mult.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}